import _ from 'lodash'
import { Becy } from '@/components/ui/icon'
import { OriginalGameCard } from '@/components/original/OriginalGameCard'
import { OriginalGameCardSkeleton } from '@/components/original/OriginalGameCardSkeleton'
import { CASINO_SKELETON_CARD_COUNT } from '@/config/casino'
import { getSortedOriginalGames } from '@/lib/original-games'
import { useGetOriginalGamesQuery } from '@/store/api/originalApi'

export function CasinoOriginalsContent() {
	const { data, isLoading, isError } = useGetOriginalGamesQuery()
	const games = getSortedOriginalGames(data?.data ?? [])

	return (
		<section className='flex flex-col gap-4'>
			<div className='flex items-center gap-3'>
				<Becy className='h-7 w-7 text-subtle-foreground' />
				<h2 className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>Originals</h2>
			</div>

			{isError ? <p className='text-sm text-muted-foreground'>Unable to load original games right now.</p> : null}

			<div className='grid grid-cols-[repeat(auto-fill,150px)] justify-center gap-6'>
				{isLoading ? _.times(CASINO_SKELETON_CARD_COUNT, (index) => <OriginalGameCardSkeleton key={`originals-skeleton-${index}`} />) : null}
				{!isLoading && !isError && _.isEmpty(games) ? (
					<p className='col-span-full text-center text-sm text-muted-foreground'>No original games are available right now.</p>
				) : null}
				{!isLoading && !isError ? _.map(games, (game) => <OriginalGameCard key={game.id} game={game} />) : null}
			</div>
		</section>
	)
}
